// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Empêche le scroll quand le menu est ouvert (mobile)
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const closeMenu = () => setOpen(false);

  return (
    <header className="Navbar">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" aria-label="Accueil" onClick={closeMenu}>
          <img src="/images/logo.png" alt="Logo Maxime H" />
        </Link>

        {/* Bouton burger (mobile) */}
        <button
          className={`nav-toggle ${open ? "is-open" : ""}`}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={open ? "true" : "false"}
          aria-controls="mainmenu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Menu */}
        <nav
          id="mainmenu"
          className={`nav-menu ${open ? "open" : ""}`}
          aria-label="Navigation principale"
        >
          <NavLink to="/" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            Accueil
          </NavLink>
          <NavLink to="/galerie" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            Galerie
          </NavLink>
          <NavLink to="/services" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            Services
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            À propos
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            Contact
          </NavLink>
          <NavLink to="/acces-clients" className={({ isActive }) => (isActive ? "active" : undefined)} onClick={closeMenu}>
            Accès clients
          </NavLink>
        </nav>
      </div>

      {/* Voile derrière le menu sur mobile */}
      {open && <div className="nav-backdrop" onClick={closeMenu} />}
    </header>
  );
}